import React from "react";
import "../components/Components.css";
import ReactWhatsapp from "react-whatsapp";
import whatsappLogo from "../images/whatsapp.png";

const WhatsappUs = () => {
  return (
    <>
      <div className="h-full">
        <section
          id="contact-hero"
          className="grid grid-rows-1 mt-10 justify-items-center "
        >
          <section className="grid md:grid-rows-4 grid-cols-1 grid-rows-1 text-center md:w-1/2 w-full mt-5 place-items-center place-self-center">
            <div>
              <h2 className="  text-5xl place-self-center font-bold">
                CONTACT US!
              </h2>
            </div>
            <div className="flex justify-self-center">
              <p className=" flex justify-self-center p-2 font-semibold">
                IWC CAN HELP YOU IN YOUR TRADING JOURNEY!
              </p>
            </div>
            <button className="w-72 h-16 text-black text-left place-self-center items-center flex p-4 font-semibold  bg-mgreen rounded-lg border border-black border-4">
              <ReactWhatsapp
                className="w-full grid grid-cols-5 items-center"
                number="+65 8083 6872"
                message="Hi! I was referred to you by your website! I would like to know more about IWC and 1KadayClub."
              >
                <div className="col-span-1 flex justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    className="w-6 h-6 text-black"
                  >
                    <path d="M20.52 3.48A11.82 11.82 0 0012 0a11.81 11.81 0 00-10 17.94L0 24l6.18-1.95A11.81 11.81 0 0012 24a11.8 11.8 0 008.36-20.52zM12 21.83a9.82 9.82 0 01-5-1.36l-.36-.21-3.67 1.15 1.17-3.58-.23-.38A9.81 9.81 0 1112 21.83zm5.53-7.59c-.3-.15-1.79-.88-2.07-.98s-.48-.15-.68.15-.78.98-.95 1.18-.35.22-.65.07a8.01 8.01 0 01-2.36-1.46 8.93 8.93 0 01-1.67-2.07c-.18-.3 0-.46.13-.6.13-.13.3-.35.45-.52s.2-.3.3-.5.05-.38-.03-.52c-.08-.15-.68-1.65-.93-2.26-.25-.6-.5-.52-.68-.53h-.6c-.2 0-.52.08-.8.38a3.37 3.37 0 00-1.12 2.52c0 1.49 1.07 2.93 1.22 3.13.15.2 2.1 3.2 5.1 4.47.71.3 1.26.48 1.7.61a4.2 4.2 0 001.93.12c.59-.09 1.79-.73 2.05-1.43.25-.7.25-1.3.18-1.43-.07-.12-.28-.2-.6-.35z" />
                  </svg>
                </div>

                <h4 className="col-span-4 flex items-center justify-self-start text-sm md:text-base font-bold">
                  SEND US A MESSAGE
                </h4>
              </ReactWhatsapp>
            </button>
          </section>
        </section>
      </div>
    </>
  );
};

export default WhatsappUs;
